import { render, staticRenderFns } from "./TileQuality.vue?vue&type=template&id=b672f43a"
import script from "./TileQuality.vue?vue&type=script&lang=js"
export * from "./TileQuality.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports